
export const ProjectData = [
  {
    image: require("../assets/img/next-amazone.png"),
    name: "Amazone clone",
    type: "developpement web",
    date: "Juin 2021",
    description:
      "Un clone complet d'amazone",
    github: "https://github.com/TiavinaRakotobe/tiavinarakotobe",
    external: "https://next-ti-ta-ekomasu.vercel.app/",
    technos: ["NextJS", "ReactJS", "TailwindCSS","Firebase","NextAuth","redux"]
  },
    {
      image: require("../assets/img/hulu.png"),
      name: "HULU clone",
      type: "developpement web",
      date: "Juin 2021",
      description:
        "Un simple clone de hulu",
      github: "https://github.com/TiavinaRakotobe/tiavinarakotobe",
      external: "https://next-hulu-clone.vercel.app/?genre=fetchActionMovies",
      technos: ["NextJS", "ReactJS", "TailwindCSS"]
    },
        
    {
      image: require("../assets/img/facedevy.png"),
      name: "facedevy",
      type: "developpement web",
      date: "Juillet 2020",
      description:
        "Un réseau social (une mini fusion de facebook et linkedin).",
      github: "https://github.com/TiavinaRakotobe/tiavinarakotobe",
      external: "https://facedevy.herokuapp.com/",
      technos: ["React JS", "Redux", "MongoDB","NodeJS", "ExpressJs", "Styled-components", "Semantic UI"]
    },
      {
        image: require("../assets/img/inashite.png"),
        name: "inashite",
        type: "developpement web",
        date: "Juin 2020",
        description:
          "Application de chat comme Discord ou Slack",
        github: "https://github.com/TiavinaRakotobe/tiavinarakotobe",
        external: " https://hanashi-t.web.app/",
        technos: ["React JS", "Redux", "Firebase/Firestore", "Styled-components", "Semantic UI"]
      },

      {
        image: require("../assets/img/uirusu.PNG"),
        name: "Uirusu",
        type: "developpement web",
        date: "Avril 2020",
        description:
          "Application de tracker de donnée COVID19 avec carte intéractive.",
        github: "https://github.com/TiavinaRakotobe/uirusu",
        external: "https://uirusu.netlify.app/",
        technos: ["React JS", "Leaflet", "MapBox", "Material-UI"]
      },

        {
          image: require("../assets/img/portfolio.PNG"),
          name: "Portfolio",
          date: "Mars 2020",
          type: "developpement web",
          description:
            "Mon site personnel.",
          github: "",
          external: "",
          technos: ["React", "sytled-component", "Semantic UI"]
        },


        {
          image: require("../assets/img/Jinzai.PNG"),
          name: "Jinzai",
          date: "Novembre 2018",
          type: "developpement web",
          description:
            "Application de gestion complete d'une RH(paye, congé, etc...) avec système de validation hiérarchique.",
          github: "https://github.com/TiavinaRakotobe/jinzai",
          external: "",
          technos: ["Symfony", "MySQL"]
        }

      
      ];
export default ProjectData;